<section class="voyage-details">
    <div class="top-section">
        <h3>Shipping Line's Performance</h3>
    </div>
    <div class="container">
        <div class="main-section">
            <div class="port-calender-inner port-calender-inner-sec">
                <form [formGroup]="voyageform" class="search-section-right search-section-right-sec" (ngSubmit)="onSearch()">
                    <div class="port-calender-sec">
                        <div class="calender-frm">
                            <div class="select-sec">
                                <label class="custom-label">From Port</label>
                                <div class="select-section-relative">
                                    <div style="text-align:center" class="input-section input-section-sec pRel">
                                        <p-autoComplete formControlName="fromPort" [suggestions]="portsData"
                                            [dropdown]="true" [dropdown]="false" (completeMethod)="searchPorts($event,'from')"
                                            field="portName" placeholder="From Region" class="test">
                                            <ng-template let-port pTemplate="item">
                                                {{ port.portName }}
                                            </ng-template>
                                        </p-autoComplete>
                                        <span class="downArrow"><img src="../../../../../assets/images/arrow.png" /></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="calender-frm">
                            <div class="select-sec">
                                <label class="custom-label">To Port</label>
                                <div class="select-section-relative">
                                    <div style="text-align:center" class="input-section input-section-sec pRel">
                                        <p-autoComplete formControlName="toPort" [suggestions]="portsData"
                                            [dropdown]="true" [dropdown]="false" (completeMethod)="searchPorts($event,'to')"
                                            field="portName" placeholder="To Region" class="test">
                                            <ng-template let-port pTemplate="item">
                                                {{ port.portName }}
                                            </ng-template>
                                        </p-autoComplete>
                                        <span class="downArrow"><img src="../../../../../assets/images/arrow.png" /></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="calender-frm">
                            <div class="select-sec">
                                <label class="custom-label">Month</label>
                                <div class="form-group pRel">
                                    <p-dropdown [options]="mothData" formControlName="month" optionLabel="monthName"
                                        class="select-dropdown-sec" placeholder="Select Month" [virtualScroll]="true"
                                        [itemSize]="12" [filter]="false"></p-dropdown>
                                        <span class="downArrow"><img src="../../../../../assets/images/arrow.png" /></span>
                                </div>
                            </div>
                        </div>
                        <div class="calender-frm">
                            <div class="select-sec">
                                <label class="custom-label">Year</label>
                                <div class="form-group pRel">
                                    <p-dropdown [options]="yearsDataList" formControlName="year" optionLabel="viewValue"
                                        class="select-dropdown-sec" placeholder="Select Year" [virtualScroll]="true"
                                        [itemSize]="30" [filter]="false"></p-dropdown>
                                        <span class="downArrow"><img src="../../../../../assets/images/arrow.png" /></span>
                                </div>
                            </div>
                        </div>
                        <div class="btn-search text-center">
                            <button class="btn  btn-go my-2 my-sm-0" type="submit">
                                <img src="../../../assets/images/Group 103.svg" />
                            </button>
                        </div>
                    </div>
                </form>
            </div>
            <div class="border-sec"></div>
            <div class="calender-detail-sec">
                <div class="container">
                    <div class="row">
                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <div class="overFlow">
                                <p-chart type="bar" [data]="noOfVessels" [options]="options" [responsive]="true"
                                height="400px" width="500px" (onDataSelect)="selectDataOfChart($event)"></p-chart>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <div class="overFlow">
                                <p-chart type="bar" [data]="frequencyData" [options]="options" [responsive]="true"
                                        height="400px" width="500px" (onDataSelect)="selectDataOfChart($event)"></p-chart>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <div class="overFlow">
                                <p-chart type="bar" [data]="noOfPortCalls" [options]="options" [responsive]="true"
                                        height="400px" width="500px" (onDataSelect)="selectDataOfChart($event)"></p-chart>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <div class="overFlow">
                                <p-chart type="bar" [data]="voyageLength" [options]="options" [responsive]="true"
                                        height="400px" width="500px" (onDataSelect)="selectDataOfChart($event)"></p-chart>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>